module.exports = __webpack_public_path__ + "static/media/telegram_logo.feecf411.svg";